import React, { useState, useEffect } from 'react'
import { Grid, Typography, CircularProgress, Button } from '@material-ui/core'

import { useTheme } from '@material-ui/styles'

import { getLGFBalanceTransfers, getLGFItem } from './utils.js'
import { formatUnits } from '@ethersproject/units'
import { Contract } from '@ethersproject/contracts'
import { ethers } from 'ethers'

import { Pie, PieChart, ResponsiveContainer, Sector } from 'recharts'
import { createMuiTheme } from '@material-ui/core/styles'
import SimulatorPage from './Simulator'
import { BigNumber } from '@ethersproject/bignumber'
import { coingeckoETH } from './utils'

// import { useMaterialUIController } from '../../context'
import {
    useContractCall,
    useEthers,
    useContractFunction,
    useTokenBalance,
} from '@usedapp/core'
// styles
import useStyles from './styles'
import { utils } from 'ethers'

// components
import PageTitle from '../../components/PageTitle/PageTitle'
import Widget from '../../components/Widget/Widget'
import axios from 'axios'

import dividendABI from '../../abi/dividend.json'
import claimABI from '../../abi/claim.json'

axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded'

// Contracts
const JPG_CONTRACT = '0x19e5bb63c902c0690d1ba9b946ee8920e8dec3c6'

// Create our number formatter.
var formatter = new Intl.NumberFormat()

// Create our number formatter.
var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})
//"en-IN", {
//  maximumSignificantDigits: 3,
//});

async function transfers(chainId, contract, wallet) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/transfers_v2/${wallet}/${contract}/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}

async function portfolio(chainId, wallet) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/portfolio_v2/${wallet}/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}

async function balance(chainId, contract) {
    try {
        return await axios.get(
            `https://effortless-leaf-336220.uc.r.appspot.com/balances_v2/${contract}/false/${chainId}`
        )
    } catch (error) {
        console.error(error.message)
    }
}

const marks = [
    {
        value: 0,
        label: '0%',
    },

    {
        value: 5,
        label: '5%',
    },
    {
        value: 10,
        label: '10%',
    },
]

function valuetext(value) {
    return `${value}°C`
}

// here I set the them
const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTableHead: {
                root: {
                    backgroundColor: '#EE266D;',
                },
            },
        },
    })
const datatableData = []

datatableData.push([1, parseFloat(0), formatterUS.format(parseFloat(0)), 1])

const simpleContractInterface = new ethers.utils.Interface(dividendABI)

export function useDividend(account) {
    const [dividend] =
        useContractCall({
            abi: simpleContractInterface,
            address: JPG_CONTRACT,
            method: 'withdrawableDividendOf',
            args: [account],
        }) ?? []
    return dividend
}

function PortfolioPage() {
    var classes = useStyles()
    var theme = useTheme()
    // const [controller] = useMaterialUIController()
    // const { wallet } = controller
    //  console.log('wallet ', wallet)

    const { account } = useEthers()
    // TODO
    const tokenBalance = useTokenBalance(JPG_CONTRACT, account)
    const tokenBalanceF = tokenBalance ? formatUnits(tokenBalance, 18) : 0
    const dividend = useDividend(account)
    const [claimDisabled, setClaimDisabled] = useState(false)

    const dividendF = dividend ? formatUnits(dividend, 18) : 0

    // Wallet Account
    //  const wallet = localStorage.getItem('account')
    // local
    var [activeIndex, setActiveIndexId] = useState(0)

    const [price, setPrice] = useState(0)
    const [priceLoader, setPriceLoader] = useState(0)
    const [ethPrice, setETHPrice] = useState(0)
    const [ethPriceLoader, setETHPriceLoader] = useState(0)

    const [pieChartData, setPieChartData] = useState([
        {
            name: 'Transfers',
            value: tokenBalanceF,
        },
        {
            name: 'Reflections',
            value: 0,
        },
    ])

    const wethClaimInterface = new utils.Interface(claimABI)
    const contract = new Contract(JPG_CONTRACT, wethClaimInterface)
    const { state, send: claimH } = useContractFunction(contract, 'claim', {})
    const { state: stateCompound, send: claimC } = useContractFunction(
        contract,
        'compound'
    )

    function handleClaim() {
        try {
            setClaimDisabled(true)
            claimH()
        } catch (e) {
            console.log(e)
        }
    }

    function handleCompound() {
        try {
            setClaimDisabled(true)
            var options = {
                gasLimit: 500000,
            }

            claimC(options)
        } catch (e) {
            console.log(e)
        }
    }

    // 1. CLAIM
    useEffect(() => {
        if (state.status === 'Success') {
            setClaimDisabled(false)
        }
        if (state.status === 'Exception' || state.status === 'Fail') {
            setClaimDisabled(false)
            console.log(state.errorMessage)
            // setApprovalError(state.errorMessage)
        }
    }, [state])

    // 2. Compound
    useEffect(() => {
        if (stateCompound.status === 'Success') {
            setClaimDisabled(false)
        }
        if (
            stateCompound.status === 'Exception' ||
            stateCompound.status === 'Fail'
        ) {
            setClaimDisabled(false)
            console.log(stateCompound.errorMessage)
            // setApprovalError(state.errorMessage)
        }
    }, [stateCompound])

    useEffect(() => {
        const fetchPrice = async contract => {
            setPriceLoader(1)

            try {
                const response = await balance(1, contract)
                const jpgPrice =
                    response.data.data.data.items[0].contract_address ===
                    contract
                        ? response.data.data.data.items[0].quote_rate
                        : response.data.data.data.items[1].quote_rate
                setPrice(jpgPrice)
            } catch (error) {
                console.error(error.message)
            }
            setPriceLoader(0)
        }

        const ethPrice = async () => {
            setETHPriceLoader(1)

            try {
                const ethResponse = await coingeckoETH()
                setETHPrice(parseFloat(ethResponse.data.ethereum.usd))
            } catch (error) {
                console.error(error.message)
            }
            setETHPriceLoader(0)
        }

        const refresh = async () => {
            await Promise.all([fetchPrice(JPG_CONTRACT), ethPrice()])
            setPieChartData([
                {
                    name: 'Transfers',
                    value: tokenBalance ? tokenBalanceF : 0,
                },
                {
                    name: 'Reflections',
                    value: tokenBalance ? tokenBalanceF : 0,
                },
            ])
        }

        refresh()
    }, [account])

    // console.log('price ', dividendF, ethPrice, dividendF * ethPrice)
    return account ? (
        <>
            <PageTitle title="Actual Balance & Earnings" />

            <Grid container>
                <Grid item xs={12} md={12}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Widget title="Balance ($JPG)" disableWidgetMenu>
                                <div className={classes.dashedBorder}>
                                    <Typography
                                        variant="h1"
                                        className={classes.text}
                                    >
                                        {formatter.format(tokenBalanceF)}
                                    </Typography>
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Widget
                                title="Balance Value (USD)"
                                disableWidgetMenu
                            >
                                <div className={classes.dashedBorder}>
                                    <Typography
                                        variant="h1"
                                        className={classes.text}
                                    >
                                        {!priceLoader ? (
                                            formatterUS.format(
                                                tokenBalance
                                                    ? tokenBalanceF *
                                                          parseFloat(price * 1)
                                                    : 0
                                            )
                                        ) : (
                                            <CircularProgress
                                                size={26}
                                                className={classes.loginLoader}
                                            />
                                        )}
                                    </Typography>
                                </div>
                            </Widget>
                        </Grid>
                    </Grid>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={6}>
                            <Widget title="Earning (ETH)" disableWidgetMenu>
                                <div className={classes.dashedBorder}>
                                    <Typography
                                        variant="h1"
                                        className={classes.text}
                                    >
                                        {!priceLoader ? (
                                            formatter.format(dividendF)
                                        ) : (
                                            <CircularProgress
                                                size={26}
                                                className={classes.loginLoader}
                                            />
                                        )}
                                    </Typography>
                                    <Button
                                        onClick={handleClaim}
                                        disabled={
                                            claimDisabled ||
                                            !(tokenBalanceF > 0)
                                        }
                                        color="primary"
                                        variant="outlined"
                                    >
                                        Claim
                                    </Button>
                                    <Button
                                        onClick={handleCompound}
                                        disabled={
                                            claimDisabled ||
                                            !(tokenBalanceF > 0)
                                        }
                                        color="primary"
                                        variant="outlined"
                                    >
                                        Compound
                                    </Button>

                                    {/*    <Typography
                                        className={classes.notification}
                                    ></Typography> */}
                                </div>
                            </Widget>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Widget
                                title="Earning Value (USD)"
                                disableWidgetMenu
                            >
                                <div className={classes.dashedBorder}>
                                    <Typography
                                        variant="h1"
                                        className={classes.text}
                                    >
                                        {!ethPriceLoader ? (
                                            formatterUS.format(
                                                dividendF * ethPrice
                                            )
                                        ) : (
                                            <CircularProgress
                                                size={26}
                                                className={classes.loginLoader}
                                            />
                                        )}
                                    </Typography>

                                    {/*    <Typography
                                        className={classes.notification}
                                    ></Typography> */}
                                </div>
                            </Widget>
                        </Grid>
                        {/*   <Grid item xs={12} md={6}>
                            <Widget title="Earning (USD)" disableWidgetMenu>
                                <div className={classes.dashedBorder}>
                                    <Typography
                                        variant="h1"
                                        className={classes.text}
                                    >
                                        {!priceLoader ? (
                                            formatter.format(
                                                dividendF *
                                                    parseFloat(price * 1)
                                            )
                                        ) : (
                                            <CircularProgress
                                                size={26}
                                                className={classes.loginLoader}
                                            />
                                        )}
                                    
                                    </Typography>
                                </div>
                            </Widget>
                        </Grid> */}
                    </Grid>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Grid
                        container
                        alignItems="center"
                        spacing={4}
                        direction="column"
                    >
                        {/*   <Grid item xs={12} md={12}>
                            <Widget
                                title="Earning Repartition"
                                upperTitle
                                disableWidgetMenu
                            >
                                <ResponsiveContainer width={310} height={210}>
                                    <PieChart width={300} height={300}>
                                        <Pie
                                            activeIndex={activeIndex}
                                            activeShape={renderActiveShape}
                                            data={[
                                                {
                                                    name: 'Transfers',
                                                    value: tokenBalance
                                                        ? formatUnits(
                                                              tokenBalance,
                                                              9
                                                          )
                                                        : 0,
                                                },
                                                {
                                                    name: 'Reflections',
                                                    value: 0,
                                                },
                                            ]}
                                            innerRadius={40}
                                            outerRadius={50}
                                            fill={theme.palette.secondary.main}
                                            dataKey="value"
                                            onMouseEnter={(e, id) =>
                                                setActiveIndexId(id)
                                            }
                                        />
                                    </PieChart>
                                </ResponsiveContainer>
                            </Widget>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Grid>
            {/*  {!priceLoader ? (
                <SimulatorPage
                    totaSuply={500000000000}
                    lgfPrice={price}
                    lgfPriceLoader={priceLoader}
                />
            ) : (
                <></>
            )} */}
        </>
    ) : (
        <>
            <PageTitle title="Actual Balance & Earnings" />

            <Grid container>
                <Typography variant="info" display="inline-block">
                    Please CONNECT FIRST :)
                </Typography>
            </Grid>
        </>
    )
}

// ################################################################

function renderActiveShape(props) {
    var RADIAN = Math.PI / 180
    var {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
        percent,
        value,
    } = props
    var sin = Math.sin(-RADIAN * midAngle)
    var cos = Math.cos(-RADIAN * midAngle)
    var sx = cx + outerRadius * cos
    var sy = cy + outerRadius * sin
    var mx = cx + outerRadius * cos
    var my = cy + outerRadius * sin
    var ex = mx + (cos >= 0 ? 1 : -1) * 22
    var ey = my
    var textAnchor = cos >= 0 ? 'start' : 'end'

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
                {payload.name}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={fill}
            />
            <path
                d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
                stroke={fill}
                fill="none"
            />
            <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                textAnchor={textAnchor}
                fill="#333"
            >{`${value}`}</text>
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                dy={18}
                textAnchor={textAnchor}
                fill="#999"
            >
                {`(${(percent * 100).toFixed(2)}%)`}
            </text>
        </g>
    )
}

export default PortfolioPage
